import React from 'react';

const Dot = () => {
  return <span>&nbsp;•&nbsp;</span>;
};

export default Dot;
